import React, { FC } from 'react'

import { ServiceCardView } from './ServiceCardView'
import { useServiceCard } from '../hooks/useServiceCard'
import { TServiceCardContent } from '../types/ServiceCard.types'

export const ServiceCard: FC<TServiceCardContent> = ({ title, confirmButton, details, to }) => {
  const { content, onClick } = useServiceCard({
    confirmButton,
    details,
    title,
    to,
  })

  return <ServiceCardView content={content} onClick={onClick} />
}
